import Vue from 'vue'
import VueI18n from 'vue-i18n'

import q_zh from 'quasar/lang/zh-hans'
import q_en from 'quasar/lang/en-us'
import q_ru from 'quasar/lang/ru'

Vue.use(VueI18n)

/*var lang = localStorage.getItem('lang') || 'zh';
export default new VueI18n({ //语言切换设置
   locale:lang, //切换语言 this.$i18n.locale = 'en';
   messages:{
     'zh':require('./lang/zh'),//将项目中的语言包与ui框架的语言包合并
     'en':require('./lang/en'),
     'ru':require('./lang/ru'),
   },
})*/

function loadLocaleMessages () {
  const locales = require.context('./lang', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export default new VueI18n({
  locale: localStorage.getItem('lang') || 'zh',//process.env.VUE_APP_I18N_LOCALE
  fallbackLocale: localStorage.getItem('lang') || 'zh',//process.env.VUE_APP_I18N_LOCALE
  messages: loadLocaleMessages()
})
